import { Navigate } from 'react-router-dom'
import { PortalLoading } from '@/routes/appointments/portal-shell'
import { trpc } from '@/trpc/client'

/**
 * /appointments — renders under RequirePatientAuth, so a session exists;
 * resolve the patient id and redirect to the viewer.
 */
export function PatientPortalIndex() {
	const { data: me } = trpc.patientPortal.me.useQuery(undefined, {
		retry: false,
	})

	if (!me) {
		return <PortalLoading />
	}

	return <Navigate to={`/appointments/${me.id}`} replace />
}
